import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 *  Migration to add originalIrisByCurrentIri to the draft model data
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v36 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v36Projects(prevState.projects);
  }

  return nextState;
};

const v36Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    if (!project.diagram.model.modelData.draftData) {
      projectsById[projectId] = project;
      return;
    }

    projectsById[projectId] = {
      ...project,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          modelData: {
            ...project.diagram.model.modelData,
            draftData: {
              ...project.diagram.model.modelData.draftData,
              originalIrisByCurrentIri: {},
            },
          },
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
